<template>
    <template v-if="waSpecificUpsells.length > 0">
        <template v-for="service, key) in waSpecificUpsells" :key="service.id">
            <div class="d-flex justify-content-between align-items-center py-2 gap-3">
                <span class="d-flex align-items-center flex-fill">
                    <span class="fw-bold">{{ service.name }}</span>
                    <div class="d-flex" @click="toggleInfoModal(service)" data-bs-toggle="modal" data-bs-target="#infoModal">
                        <i class="fa-regular fa-info-circle cursor-pointer ms-2"></i>
                    </div>
                </span>
                <button
                    type="button"
                    :class="serviceInBasket(service.code) ? 'btn-custom-red' : 'btn-custom-white'"
                    class="btn text-16 fw-bold"
                    @click="toggleWAInBasket(service.code, productInBasket(service.code))"
                >
                    <template v-if="serviceInBasket(service.code)">
                        <span>Remove</span>
                    </template>
                    <template v-else>
                        <span
                            v-if="service.price_type =='per_tyre'"
                        >
                            Add for £{{ (service.retail * (basket.total_tyres ?? 1)).toFixed(2) }}
                        </span>
                        <span
                            v-else
                        >
                            Add for £{{ service.retail }}
                        </span>
                    </template>
                </button>
            </div>
            <hr v-if="waSpecificUpsells.length > 1 || otherUpsells.length > 0">
        </template>
    </template>
    <template v-if="otherUpsells.length > 0">
        <template v-for="service, key) in otherUpsells" :key="service.id">
            <div class="d-flex justify-content-between align-items-center py-2 gap-3">
                <span class="d-flex align-items-center flex-fill">
                    <span class="fw-bold">{{ service.name }}</span>
                    <div class="d-flex" @click="toggleInfoModal(service)" data-bs-toggle="modal" data-bs-target="#infoModal">
                        <i class="fa-regular fa-info-circle cursor-pointer ms-2"></i>
                    </div>
                </span>
                <button
                    type="button"
                    :class="serviceInBasket(service.code) ? 'btn-custom-red' : 'btn-custom-white'"
                    class="btn text-16 fw-bold"
                    @click="serviceInBasket(service.code) ? deleteServiceFromBasket(service.code) : this.addServiceToBasket(service.code, (service.price_type == 'per_tyre' ? basket.total_tyres : 1))"
                >
                    <template v-if="serviceInBasket(service.code)">
                        <span>Remove</span>
                    </template>
                    <template v-else>
                        <span
                            v-if="service.price_type =='per_tyre'"
                        >
                            Add for £{{ (service.retail * (basket.total_tyres ?? 1)).toFixed(2) }}
                        </span>
                        <span
                            v-else
                        >
                            Add for £{{ service.retail }}
                        </span>
                    </template>
                </button>
            </div>
            <hr v-if="key != otherUpsells.length -1 ">
        </template>
    </template>
</template>

<script>
    import basketFunctions from "@shared/mixins/basket";

    export default {
        mixins: [basketFunctions],
        props: ['services', 'basket'],
        data() {
            return {
                waValues: ['WHEELALIGNMENT', 'RCWHEELALIGN4']
            }
        },
        methods: {
            async toggleInfoModal(upsell) {
                this.emitter.emit('openInfoModal', {heading: upsell.name + ' Tyres', text: '<p>' + upsell.long_description + '</p>', size: 'modal-xl'});
            },
            serviceInBasket(st_code) {
                if(this.basket.products) {
                    let query = this.basket.products.filter((basket_product) => {
                        return (basket_product.st_code == st_code);
                    });

                    return query.length > 0 ? true : false;
                }
            }
        },
        computed: {
            waSpecificUpsells() {
                let vm = this;
                return this.services?.available.filter((service) => {
                    return (vm.waValues.includes(service.code));
                });
            },
            otherUpsells() {
                let vm = this;
                return this.services?.available.filter((service) => {
                    return (!vm.waValues.includes(service.code));
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .service-modal-tooltip {
        cursor: pointer;
    }
</style>